const getSupplierFax2 = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return business && business['Company Contact'] && business['Company Contact'].Fax
    ? business['Company Contact'].Fax.replace('+1 ', '').replace(/[\s()-]/g, '').slice(3, 6) : null;
};

export default getSupplierFax2;



// WEBPACK FOOTER //
// ./src/utils/print/getSupplierFax2.js